import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import findKey from 'lodash/findKey';

import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
import { ToolSetOptions, ToolSetOptionsItem } from '../../../../../components/ToolSet';
import { getDefaultSort, getSortNameMap, sortTypeMap } from '../../../../../utils/sortHelper';
import { getSortByParam } from '../../../../../store/actions';

import {getParserEngineCommonFunctions} from '../../../../../utils/urlHelpers/engineConstantsParsers';
import { getMessages } from '../../../../../tppServices/translations/messages';

class SortBy extends PureComponent {

  state = {
    initialState: this.props.initialState || 'open',
    selectedValue: 'length:desc'
  };

  setSelectedValue() {
    let urlParams = get(this.props, 'match.params', {});
    const params = get(this.props, 'params', {});
    if (urlParams.sort) {
      const { parseEngineSortParams } = getParserEngineCommonFunctions(null, this.context);
      let value = parseEngineSortParams(urlParams.sort).sort;
      this.setState({ selectedValue: value });
    } else if (params.sort){
      const value = findKey(sortTypeMap, (key) => key === params.sort);
      this.setState({ selectedValue: value });
    } else {
      this.setState({ selectedValue: getDefaultSort(urlParams.postalCode) });
    }
  }

  componentDidMount() {
    this.setSelectedValue();
  }

  componentDidUpdate() {
    this.setSelectedValue();
  }

  handleDataChange(value){
    let { onDataChange } = this.props;
    this.setState({selectedValue: value});

    if (onDataChange){
      onDataChange(value);
    }

    this.props.getSortByParam(value);
  }

  render(){
    const { intl: { formatMessage: t } } = this.props;
    const messages = getMessages();
    const sortNameMap = getSortNameMap();
    let { closeOnOuterClick, closeOnInnerClick } = this.props;
    let { initialState, selectedValue } = this.state;
    let name = sortNameMap[selectedValue];

    return (
      <CollapsibleContent
        initialState={initialState}
        closeOnOuterClick={closeOnOuterClick}
        closeOnInnerClick={closeOnInnerClick}
      >
        <CollapsibleHeader type="sort-title" priority={0}>
          {t(messages.searchHeader.sort.sortBy)}<span> :</span>
          <span className="criteria bp3">
            <span className="text">
              <span className="ref-length-longest-first">{t(name)}</span>
            </span>
          </span>
        </CollapsibleHeader>
        <Collapsible>
          <ToolSetOptions>
            <ToolSetOptionsItem id="year-newest-first" name="sort-by" value="year:desc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'year:desc'}>
              {t(messages.searchHeader.sort.newestYear)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="year-oldest-first" name="sort-by" value="year:asc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'year:asc'}>
              {t(messages.searchHeader.sort.oldestYear)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="price-high-first" name="sort-by" value="price:desc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'price:desc'}>
              {t(messages.searchHeader.sort.pricey)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="price-low-first" name="sort-by" value="price:asc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'price:asc'}>
              {t(messages.searchHeader.sort.cheapest)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="make-high-first" name="sort-by" value="make:desc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'make:desc'}>
              {t(messages.searchHeader.sort.lastMake)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="make-low-first" name="sort-by" value="make:asc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'make:asc'}>
              {t(messages.searchHeader.sort.firstMake)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="powerhp-high-first" name="sort-by" value="powerhp:desc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'powerhp:desc'}>
              {t(messages.searchHeader.sort.mostPowerful)}
            </ToolSetOptionsItem>
            <ToolSetOptionsItem id="powerhp-low-first" name="sort-by" value="powerhp:asc" onClick={this.handleDataChange.bind(this)} selected={selectedValue === 'powerhp:asc'}>
              {t(messages.searchHeader.sort.leastPowerful)}
            </ToolSetOptionsItem>
          </ToolSetOptions>
        </Collapsible>
      </CollapsibleContent>
    );
  }
}

SortBy.propTypes = {
  closeOnInnerClick: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.any
  ]),
  closeOnOuterClick: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.any
  ]),
  getSortByParam: PropTypes.func.isRequired,
  initialState: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onDataChange: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.any
  ])
};

export default connect(null, dispatch => bindActionCreators({ getSortByParam }, dispatch))(injectIntl(SortBy));
